import { useTranslation } from 'react-i18next';
import { useGetRequiredRule } from '@/hooks';
import { FilterFormFieldNames } from '../helpers/types';
import { useGetSlugRule } from 'src/shared/hooks/formValidations';

export const useFilterFormValidationRules = (isEdit: boolean) => {
  const { t } = useTranslation(['validations']);

  const requiredRule = useGetRequiredRule({ t });
  const slugRule = useGetSlugRule({ t });

  return {
    [FilterFormFieldNames.LOCALE]: [requiredRule],
    [FilterFormFieldNames.POSITION]: [requiredRule],
    [FilterFormFieldNames.TYPE]: [requiredRule],
    [FilterFormFieldNames.STATUS]: [requiredRule],
    [FilterFormFieldNames.IS_REQUIRED]: [requiredRule],
    [FilterFormFieldNames.IS_SHOWN]: [requiredRule],
    ...(isEdit && { [FilterFormFieldNames.SLUG]: [requiredRule, slugRule] }),
  };
};
